import { Card, CardBody, Col, Form, FormGroup, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { DebitCards, DebitMonthSelect, DebitYearSelect, ExpirationDate, Submit } from "../../../Constant";
import FormGroupCommon from "./Common/FormGroupCommon";
import SelectCommon from "./Common/SelectCommon";
import { Btn } from "../../../AbstractElements";

const DebitCard = () => {
  return (
    <Col xl="4" lg="6" className="box-col-33 debit-card">
      <Card>
        <CommonCardHeader title={DebitCards} />
        <CardBody>
          <Form className="theme-form e-commerce-form" onSubmit={(e) => e.preventDefault()}>
            <Row>
              <FormGroupCommon type="text" placeholder="Full name here" formClass="col-6 p-r-0" />
              <FormGroupCommon type="text" placeholder="Card number" formClass="col-6" />
              <FormGroupCommon type="text" placeholder="CVV number" formClass="col-6 p-r-0" />
              <FormGroupCommon type="text" placeholder="CVC" formClass="col-6" />
              <FormGroup className="col-12">
                <Label className="col-form-label">{ExpirationDate}</Label>
              </FormGroup>
              <SelectCommon size={1} data={DebitMonthSelect} selectClass="col-6 p-r-0" />
              <SelectCommon size={1} data={DebitYearSelect} selectClass="col-6" />
            </Row>
            <Col xs="12">
              <Btn color="primary" className="btn-block">
                {Submit}
              </Btn>
            </Col>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DebitCard;
